import parse from "html-react-parser";
import "./hero.scss";
import ButtonUI from "../Button";
import Div from "../Div";
import Row from "react-bootstrap/Row";
import Spacing from "../Spacing";

export default function Hero8({
  title,
  subtitle,
  btnText,
  btnLink,
  bgImageUrl,
  bgImageUrlWebp,
  btnVariant,
  btnTextColor,
  btnTextHoverColor,
  backgroundColor,
  backgroundHoverColor,
  scrollDownId,
  btnTarget,
}) {
  return (
    <Div
      className="cs-hero cs-style1 cs-bg cs-shape_wrap_1 text-center cs-type1 cs-fixed_bg"
      style={{ backgroundImage: `url(${bgImageUrlWebp})` }}
    >
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="container">
        <Row>
          <Spacing lg="30" md="30" />
          <Div className="cs-hero_text">
            <h1 className="cs-hero_title">{parse("Eduardo Schroeder")}</h1>
            <Spacing lg="30" md="30" />
            <h1 className="cs-hero_title">{parse(title)}</h1>
            <Div className="cs-hero_subtitle">{subtitle}</Div>
            <Spacing lg="30" md="30" />
            <Div className="cs-cta_in">
              <ButtonUI
                btnTarget={btnTarget}
                btnLink={btnLink}
                btnText={btnText}
                variant={btnVariant}
                backgroundColor={backgroundColor}
                btnTextColor={btnTextColor}
                btnTextHoverColor={btnTextHoverColor}
                backgroundHoverColor={backgroundHoverColor}
              />
            </Div>
          </Div>{" "}
        </Row>
      </Div>
      <a href={scrollDownId} className="cs-down_btn">
        .
      </a>
    </Div>
  );
}
